<template>
  <div class="navigation">
        <div class="navbar navbar-expand-lg navbar-light p-0 w-100 ">
            <button class="navbar-toggler navigation__button"
                    type="button" data-toggle="collapse"
                    data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbar">
                <div class="navigation__item dropdown" v-for="(link, key) in links">
                    <template v-if="link.hasSubLinks">
                        <a href="#"
                           class="dropdown-toggle navigation__item__title"
                           role="button"
                           :id="'dropdownMenuLink' + key"
                           data-toggle="dropdown"
                           aria-haspopup="true"
                           aria-expanded="false">{{ link.name }}</a>
                        <div class="dropdown-menu dropdown-menu__child_1 navigation__item__menu " :aria-labelledby="'dropdownMenuLink' + key">
                            <template v-for='(subLink, subkey) in link.subLinks'>
                                <template v-if="subLink.hasSubLinks">
                                    <a class="dropdown-item navigation__item__menu--link dropdown-toggle dropdown-menu__child_1__link"
                                       href="#"
                                       :id="'dropdownMenuLink' + key + subkey"
                                       data-toggle="dropdown"
                                       aria-haspopup="true"
                                       aria-expanded="false"
                                    >{{subLink.name}}</a>
                                    <div class="dropdown-menu dropdown-menu__child_2 navigation__item__menu "
                                         :aria-labelledby="'dropdownMenuLink' + key + subkey">

                                        <a :href="sublink.url" class="dropdown-item navigation__item__menu--link dropdown-menu__child_2__link"
                                           v-for="sublink in subLink.subLinks">{{sublink.name}}</a>
                                    </div>
                                </template>
                                <template v-else>
                                    <a class="dropdown-item navigation__item__menu--link dropdown-menu__child_1__link"
                                       :href="subLink.url">{{subLink.name}}</a>
                                </template>
                            </template>
                        </div>
                    </template>
                    <template v-else>
                        <a :href="link.url">{{ link.name }}</a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const GLOBAL_URL = 'https://www.dynassurances.fr/';

    export default {
        name: 'Navigation',
        data() {
            return {
                links: [
                    {
                        name: 'Qui sommes-nous', url: '#', hasSubLinks: true,
                        subLinks: [
                            {name: 'Présentation', url: GLOBAL_URL + 'presentation.php'},
                            {name: 'Chiffres clés', url: GLOBAL_URL + 'chiffres-cles.php'},
                            {name: 'Notre développement', url: GLOBAL_URL + 'notre-developpement.php'},
                            {name: 'Nos métiers', url: GLOBAL_URL + 'nos-metiers.php'},
                        ]
                    },
                    {
                        name: 'Nos services', url: '#', hasSubLinks: true,
                        subLinks: [
                            {
                                name: 'Risque des entreprises', url: '#', hasSubLinks: true, subLinks: [
                                    {
                                        name: 'La Responsabilité civile',
                                        url: GLOBAL_URL + 'assurance/assurance-rc.php'
                                    },
                                    {
                                        name: 'les flottes Automobiles',
                                        url: GLOBAL_URL + 'assurance/assurance-flottes-automobiles.php'
                                    },
                                    {
                                        name: 'L\'assurance Construction',
                                        url: GLOBAL_URL + 'assurance/assurance-construction.php'
                                    },
                                    {
                                        name: 'Le transport de marchandises',
                                        url: GLOBAL_URL + 'assurance/assurance-transport-marchandises.php'
                                    }
                                ]
                            },
                            {
                                name: 'Risque du particulier', url: '#', hasSubLinks: true, subLinks: [
                                    {name: 'Auto', url: GLOBAL_URL + 'assurance/assurance-auto.php'},
                                    {name: 'Moto', url: GLOBAL_URL + 'assurance/assurance-moto.php'},
                                    {name: 'Habitation', url: GLOBAL_URL + 'assurance/assurance-habitation.php'},
                                    {name: 'Autres assurances', url: GLOBAL_URL + 'assurance/autres-assurances.php'},
                                ]
                            },
                            {
                                name: 'Les garanties «Pannes Mécaniques»', url: '#', hasSubLinks: true, subLinks: [
                                    {name: 'Les contrats de garantie CGA', url: GLOBAL_URL + 'panne-mecanique/cga.php'},
                                    {name: 'La gestion pour compte FGAS', url: GLOBAL_URL + 'panne-mecanique/fgas.ph'},
                                ]
                            },

                            {
                                name: 'Le Camping-car', url: '#', hasSubLinks: true, subLinks: [
                                    {name: 'Les garanties assistance', url: GLOBAL_URL + 'camping-car/assistance.php'},
                                    {name: 'La panne mécanique', url: GLOBAL_URL + 'camping-car/panne-mecanique.php'},
                                    {name: 'L\'assurance dommages', url: GLOBAL_URL + 'camping-car/assurance.php'},
                                ]
                            },
                            /*



*/
                        ]
                    },
                    {
                        name: 'Devenir partenaire', url: GLOBAL_URL + 'devenir-partenaire.php', hasSubLinks: false
                    },
                    {
                        name: 'L\'actualité Dynassurances', url: GLOBAL_URL + 'actualite-dynassurances.php', hasSubLinks: false
                    },
                    {
                        name: 'L\'équipe', url: GLOBAL_URL + 'equipe.php', hasSubLinks: false
                    },
                    {
                        name: 'Contactez-nous', url: GLOBAL_URL + 'contact.php', hasSubLinks: false
                    },
                    {
                        name: 'Devis immédiat', url: '#', hasSubLinks: true,
                        subLinks: [
                            {
                                name: 'Camping-car',
                                url: GLOBAL_URL + 'camping-car/assurance-devis.php',
                                hasSubLinks: false
                            },
                            {name: 'Auto', url: GLOBAL_URL + 'assurance/assurance-auto-devis.php', hasSubLinks: false},
                            {name: 'Moto', url: GLOBAL_URL + 'assurance/assurance-moto-devis.php', hasSubLinks: false},
                            {name: 'Habitation', url: GLOBAL_URL + 'assurance/assurance-habitation-devis.php', hasSubLinks: false},
                            {
                                name: 'Protection Juridique', url: '#', hasSubLinks: true, subLinks: [
                                    {
                                        name: 'Zen Prudent',
                                        url: GLOBAL_URL + 'assurance/assurance-protection-juridique-zen-prudent-devis.php'
                                    },
                                    {
                                        name: 'Zen Avisé',
                                        url: GLOBAL_URL + 'assurance/assurance-protection-juridique-zen-avise-devis.php'
                                    },
                                    {
                                        name: 'Zen Sérénité',
                                        url: GLOBAL_URL + 'assurance/assurance-protection-juridique-zen-serenite-devis.php'
                                    },
                                    {
                                        name: 'Zen Pro-Prudent',
                                        url: GLOBAL_URL + 'assurance/assurance-protection-juridique-zen-pro-prudent-devis.php'
                                    },
                                    {
                                        name: 'Zen Pro-Avisé',
                                        url: GLOBAL_URL + 'assurance/assurance-protection-juridique-zen-pro-avise-devis.php'
                                    },
                                    {
                                        name: 'Zen Pro-Sérénité',
                                        url: GLOBAL_URL + 'assurance/assurance-protection-juridique-zen-pro-serenite-devis.php'
                                    },
                                ]
                            },
                        ]
                    },
                ]
            }
        },
        methods: {},
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue